import { Subject } from "rxjs";

export enum TransportScope {
  SWAP_TRAILER = 'SWAP_TRAILER', //
  TRAILER = 'TRAILER', //
  TRAIN = 'TRAIN',
  SEMI_TRAILER_TRUCK = 'SEMI_TRAILER_TRUCK'
}

export enum TransportType {
  TRANSPORT = 'TRANSPORT', VEHICLE = 'VEHICLE'
}

export enum TransportRelevance {
  NOT_RELEVANT = 'NOT_RELEVANT', CURRENT_RELEVANT = 'CURRENT_RELEVANT', ARCHIVED = 'ARCHIVED'
}

export enum TransportStatus {
  PLANNED = 'PLANNED',
  IN_THE_INFLOW = 'IN_THE_INFLOW',
  CREATED = 'CREATED',
  REGISTERED = 'REGISTERED',
  WAITING = 'WAITING',
  RETRIEVED = 'RETRIEVED',
  LOADING_COMPLETE = 'LOADING_COMPLETE',
  COMPLETE = 'COMPLETE',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
  CANCELED_EXTERNALLY = 'CANCELED_EXTERNALLY',
  FINISHED_CANCELLED = 'FINISHED_CANCELLED',
  PAUSED = 'PAUSED',
  NOT_APPEARED = 'NOT_APPEARED',
  NONE = 'NONE'
}

export enum TransportPlanningType {
  DEFAULT = 'DEFAULT', TIMEFRAME = 'TIMEFRAME', IN_ADVANCE = 'IN_ADVANCE'
}

export enum TransportProcessingTimeStatus {
  NORMAL = 'NORMAL', NOTICE = 'NOTICE', CRITICAL = 'CRITICAL'
}

export enum TransportTaskStatus {
  NONE = 'NONE', ANY = 'ANY', IMPORTANT = 'IMPORTANT'
}

export enum TransportManagementLevel {
  LIFECYCLE = 'LIFECYCLE', LOCATION = 'LOCATION'
}

export enum RoutingPositionStartOrigin {

}

export enum TransportRoutingPositionActionType {

}

export enum StationAssignmentStrategy {

}

export enum RoutingPositionStatus {

}

export interface TransportRepresentation {

  id: number;

  name: string;

  scope: TransportScope;

}

export interface TransportReceiver {

  setTransport(transport: Transport);

}

export class Transport implements TransportRepresentation {

  id: number;
  relevance: TransportRelevance;

  identifyingNumberplate: string;
  name: string; // Transportname anhand Pattern
  transportName: string; // doppelt zu identifier, Verwendung prüfen
  vehicleTypeDictionaryKey: string; // vehicle Type = enum? also eher den enum Wert einbinden, dann auch Teil von Details Editor
  highlightingStyle: string;
  receiver: string; // Verwendung unklar
  reference: string; // evtl doppelt zu Order Reference

  theming: string;
  // transient
  currentThemingRule: string;

  currentLocationName: string;

  // detail informations - aggregated
  transportOptionMarks: string;
  transportOptionAmounts: string;
  transportOptionParameterValues: string;
  cargoOfRoutingPositions: string;

  // später zu entfernen => refactoring
  searchText: string;

  // substructures
  masterdata: TransportMasterdata = new TransportMasterdata();
  currentPosition: TransportRoutingPosition;
  nextPosition: TransportRoutingPosition;
  hasMorePositions: boolean = false;

  timing: TransportTiming = new TransportTiming();
  processing: TransportProcessing = new TransportProcessing();
  messaging: TransportMessaging = new TransportMessaging();

  // styling
  statusStyle: string;

  // nur lokal existent
  tableRowStyles: string;

  updated = new Subject<void>();

  get scope(): TransportScope {
    return this.masterdata.transportScope;
  }

  constructor(details?: any) {
    if (details != null) {
      this.update(details);
    }
  }

  update(details: any) {
    if (details != null) {
      this.id = details.id;
      this.identifyingNumberplate = details.identifyingNumberplate;
      this.name = details.name;
      this.transportName = details.transportName;
      this.vehicleTypeDictionaryKey = details.vehicleTypeDictionaryKey;
      this.highlightingStyle = details.highlightingStyle;
      this.receiver = details.receiver;
      this.reference = details.reference;
      this.transportOptionMarks = details.transportOptionMarks;
      this.transportOptionAmounts = details.transportOptionAmounts;
      this.transportOptionParameterValues = details.transportOptionParameterValues;
      this.statusStyle = details.statusStyle;
      this.currentLocationName = details.currentLocationName;
      this.cargoOfRoutingPositions = details.cargoOfRoutingPositions;

      this.theming = details.theming;

      this.masterdata = new TransportMasterdata(details.masterdata);
      if (details.currentPosition != null) {
        this.currentPosition = new TransportRoutingPosition(details.currentPosition);
      }
      if (details.nextPosition != null) {
        this.nextPosition = new TransportRoutingPosition(details.nextPosition);
      }
      this.hasMorePositions = details.hasMorePositions;

      this.timing = new TransportTiming(details.timing);
      this.processing = new TransportProcessing(details.processing);
      this.messaging = new TransportMessaging(details.messaging);

      this.tableRowStyles = '';
      if (this.processing.processingDurationCritical) {
        this.tableRowStyles += ' processing-duration-critical';
      }
      if (this.processing.processingDurationExceeded) {
        this.tableRowStyles += ' processing-duration-exceeded';
      }
      this.updated.next();
    }
  }

  public getValueByPath(path: string): any {
    return this.getValue(this, path.split('.'));
  }

  private getValue(obj: any, path: Array<string>): any {
    if (obj == null || obj == undefined) {
      return null;
    }
    if (path.length > 1) {
      const subPath = this.getSubPath(path);
      return this.getValue(obj[path[0]], subPath);
    } else {
      return obj[path[0]];
    }
  }

  private getSubPath(path: Array<string>): Array<string> {
    const result = new Array<string>();
    for (let i = 1; i < path.length; i += 1) {
      result.push(path[i]);
    }
    return result;
  }
}

export class TransportRoutingPosition {

  id: number;
  routingRuleId: number;

  /*
   * Masterdata
   */

  actionType: TransportRoutingPositionActionType;
  cargo: string;
  cargoMandatory: boolean;
  stationId: number;
  stationName: string; // nach Umbau Client Modell direkt aus Konfiguration nehmen
  stationSetId: number;
  stationSetName: string; // nach Umbau Client Modell direkt aus Konfiguration nehmen
  locationName: string;
  hint: string;
  ifsStatus1: string;
  ifsStatus2: string;
  stationAssignmentStrategy: StationAssignmentStrategy;
  backupAssignment = false;
  optionValues: string;

  /*
   * Status
   */

  positionStatus: RoutingPositionStatus;
  waitingForRetrieve: boolean;
  processingStatusModel: string;
  processingStatusModelStatus: string;
  availabilityNotificationSent: boolean;

  /*
   * sub relations
   */

  transportTasks = new Array<TransportTask>();

  issues = new Array<TransportIssue>();

  /*
   * Timing
   */

  availableFrom: Date;
  predictedDuration: number;
  start: Date;
  startSortValue: number;
  statusStart: Date;
  statusStartSortValue: number;
  startOrigin: RoutingPositionStartOrigin;
  end: Date;
  duration: number;
  statusDuration: number;

  firstTimeSlotStart: string;
  lastTimeSlotEnd: string;

  constructor(position?: any) {
    if (position != null) {

      this.id = position.id;
      this.routingRuleId = position.routingRuleId;
      this.actionType = position.actionType;
      this.cargo = position.cargo;
      this.cargoMandatory = position.cargoMandatory;
      this.stationId = position.stationId;
      this.stationName = position.stationName; // nach Umbau Client Modell direkt aus Konfiguration nehmen
      this.stationSetId = position.stationSetId;
      this.stationSetName = position.stationSetName; // nach Umbau Client Modell direkt aus Konfiguration nehmen
      this.locationName = position.locationName;
      this.hint = position.hint;
      this.ifsStatus1 = position.ifsStatus1;
      this.ifsStatus2 = position.ifsStatus2;
      this.stationAssignmentStrategy = position.stationAssignmentStrategy;
      this.backupAssignment = position.backupAssignment;
      this.optionValues = position.optionValues;
      this.positionStatus = position.positionStatus;
      this.waitingForRetrieve = position.waitingForRetrieve;
      this.processingStatusModel = position.processingStatusModel;
      this.processingStatusModelStatus = position.processingStatusModelStatus;
      this.availabilityNotificationSent = position.availabilityNotificationSent;
      // this.transportTasks = new Array<TransportTask>();
      // this.issues = new Array<TransportIssue>();
      this.availableFrom = position.availableFrom;
      this.predictedDuration = position.predictedDuration;
      this.start = position.start;
      this.startSortValue = position.startSortValue;
      this.statusStart = position.statusStart;
      this.statusStartSortValue = position.statusStartSortValue;
      this.startOrigin = position.startOrigin;
      this.end = position.end;
      this.duration = position.duration;
      this.statusDuration = position.statusDuration;
      this.firstTimeSlotStart = position.firstTimeSlotStart;
      this.lastTimeSlotEnd = position.lastTimeSlotEnd;

    }
  }

}

export class TransportTask {

}

export class TransportIssue {

}

export class TransportMasterdata {

  transportScope: TransportScope;
  transportType: TransportType;
  loadingTypeDictionaryKey: string;
  managementLevel: TransportManagementLevel;
  registrationCode: string;

  driverName: string;
  carrier: string;
  coDriver: string;
  dangerousGoods: boolean;
  dataProtectionRuleId: number;
  delayedLeave: boolean;

  identityCard: string;
  peopleCount: number;
  mail: string;
  string1: string;
  string2: string;
  supplier: string;
  numberPlate: string;
  phone: string;

  firstLoadCarrier: LoadCarrier;
  secondLoadCarrier: LoadCarrier;
  relevantLoadCarrier: LoadCarrier; // transient im client

  // processing options
  important: boolean;
  staysOnYardAsVehicle: boolean;
  intermitted: boolean;
  urgent: boolean;
  cabotageRelevant: boolean;

  pickupTruckEnabled: boolean;
  pickupTruckNumberPlate: string;
  pickupTruckTime: string;

  preloading: boolean;
  preloadingDate: string;

  constructor(masterdata?: any) {
    if (masterdata != null) {
      this.transportScope = masterdata.transportScope;
      this.transportType = masterdata.transportType;
      this.loadingTypeDictionaryKey = masterdata.loadingTypeDictionaryKey;
      this.managementLevel = masterdata.managementLevel;
      this.registrationCode = masterdata.registrationCode;

      this.driverName = masterdata.driverName;
      this.carrier = masterdata.carrier;
      this.coDriver = masterdata.coDriver;
      this.dangerousGoods = masterdata.dangerousGoods;
      this.dataProtectionRuleId = masterdata.dataProtectionRuleId;
      this.delayedLeave = masterdata.delayedLeave;

      this.cabotageRelevant = masterdata.cabotageRelevant;

      this.identityCard = masterdata.identityCard;
      this.peopleCount = masterdata.peopleCount;
      this.mail = masterdata.mail;
      this.string1 = masterdata.string1;
      this.string2 = masterdata.string2;
      this.supplier = masterdata.supplier;
      this.numberPlate = masterdata.numberPlate;
      this.phone = masterdata.phone;

      this.firstLoadCarrier = new LoadCarrier(masterdata.firstLoadCarrier);
      if (masterdata.secondLoadCarrier != null) {
        this.secondLoadCarrier = new LoadCarrier(masterdata.secondLoadCarrier);
      }
      this.relevantLoadCarrier = new LoadCarrier(masterdata.relevantLoadCarrier);

      this.important = masterdata.important;
      this.staysOnYardAsVehicle = masterdata.staysOnYardAsVehicle;
      this.intermitted = masterdata.intermitted;
      this.urgent = masterdata.urgent;

      this.pickupTruckEnabled = masterdata.pickupTruckEnabled;
      this.pickupTruckNumberPlate = masterdata.pickupTruckNumberPlate;
      this.pickupTruckTime = masterdata.pickupTruckTime;

      this.preloading = masterdata.preloading;
      this.preloadingDate = masterdata.preloadingDate;
    }
  }

}

export class LoadCarrier {
  cargo: string;
  orderReference: string;
  trailerIdentifier: string;
  trailerNumberPlate: string;
  swapTrailerNumber: string;

  constructor(loadCarrier?: any) {
    if (loadCarrier != null) {
      this.cargo = loadCarrier.cargo;
      this.orderReference = loadCarrier.orderReference;
      this.trailerIdentifier = loadCarrier.trailerIdentifier;
      this.trailerNumberPlate = loadCarrier.trailerNumberPlate;
      this.swapTrailerNumber = loadCarrier.swapTrailerNumber;
    }
  }
}

export class TransportTiming {

  planningType = TransportPlanningType.DEFAULT;
  planningDate: string;
  planningDateSortValue: number;
  inAdvanceDate: string;
  timeSlotDate: string;

  processingTimeStatus = TransportProcessingTimeStatus.NORMAL;

  start: string;
  startSortValue: number;
  relevantStart: string;
  relevantStartSortValue: number;
  entranceDate: string;
  leaveDate: string;
  end: string;

  waitingTime: number;

  timeSlotDelay: number;

  eta: string;
  pta: string;

  constructor(timing?: any) {
    if (timing != null) {
      this.planningType = timing.planningType;
      this.planningDate = timing.planningDate;
      this.planningDateSortValue = timing.planningDateSortValue;
      this.inAdvanceDate = timing.inAdvanceDate;
      this.timeSlotDate = timing.timeSlotDate;

      this.processingTimeStatus = timing.processingTimeStatus;

      this.start = timing.start;
      this.startSortValue = timing.startSortValue;
      this.relevantStart = timing.relevantStart;
      this.relevantStartSortValue = timing.relevantStartSortValue;
      this.entranceDate = timing.entranceDate;
      this.leaveDate = timing.leaveDate;
      this.end = timing.end;

      this.waitingTime = timing.waitingTime;

      this.timeSlotDelay = timing.timeSlotDelay;

      this.eta = timing.eta;
      this.pta = timing.pta;
    }
  }

}

export class TransportProcessing {

  processingDurationCritical: boolean;
  processingDurationExceeded: boolean;
  processingTime: string;
  processingTimeCurrentProcessing: string;

  inUmbrueckung: boolean;
  internal: boolean;

  status: TransportStatus;

  umbrueckung: boolean;
  pendingTaskState: TransportTaskStatus;

  hasMovementOrder: boolean;
  waitingForPulling: boolean;
  waitingOnRamp: boolean;
  wasRegistered: boolean;

  constructor(processing?: any) {
    if (processing != null) {
      this.processingDurationCritical = processing.processingDurationCritical;
      this.processingDurationExceeded = processing.processingDurationExceeded;
      this.processingTime = processing.processingTime;
      this.processingTimeCurrentProcessing = processing.processingTimeCurrentProcessing;

      this.inUmbrueckung = processing.inUmbrueckung;
      this.internal = processing.internal;

      this.status = processing.status;

      this.umbrueckung = processing.umbrueckung;
      this.pendingTaskState = processing.pendingTaskState;

      this.hasMovementOrder = processing.hasMovementOrder;
      this.waitingForPulling = processing.waitingForPulling;
      this.waitingOnRamp = processing.waitingOnRamp;
      this.wasRegistered = processing.wasRegistered;
    }
  }

}

export class TransportMessaging {

  useGlobalConnect: boolean;
  useSms: boolean;

  messagingAvailable: boolean;
  messagingLanguage: string;
  messagingReference: string;
  messagingResources: string;

  constructor(messaging?: any) {
    if (messaging != null) {
      this.useGlobalConnect = messaging.useGlobalConnect;
      this.useSms = messaging.useSms;

      this.messagingAvailable = messaging.messagingAvailable;
      this.messagingLanguage = messaging.messagingLanguage;
      this.messagingReference = messaging.messagingReference;
      this.messagingResources = messaging.messagingResources;
    }
  }

}

export class TransportSelection {
  filterText = '';
  scopeTrain: boolean;
  scopeTrailer: boolean;
  scopeSwapTrailer: boolean;
  scopeSemiTrailerTruck: boolean;
  customFilterId = -1;

  constructor(filter?: any) {
    if (filter != null) {
      this.filterText = filter.filterText != undefined ? filter.filterText : null;
      this.scopeTrain = filter.scopeTrain != undefined ? filter.scopeTrain : false;
      this.scopeTrailer = filter.scopeTrailer != undefined ? filter.scopeTrailer : false;
      this.scopeSwapTrailer = filter.scopeSwapTrailer != undefined ? filter.scopeSwapTrailer : false;
      this.scopeSemiTrailerTruck = filter.scopeSemiTrailerTruck != undefined ? filter.scopeSemiTrailerTruck : false;
      this.customFilterId = filter.customFilterId != undefined ? filter.customFilterId : null;
    }
  }
}

export class TransportCount {
  count: number = 0;
  ruleId: string | undefined;
  ruleName: string | undefined;

  constructor(transportCount?: Partial<TransportCount>) {
    if (transportCount) {
      this.count = transportCount.count || 0;
      this.ruleId = transportCount.ruleId || undefined;
      this.ruleName = transportCount.ruleName || undefined;
    }

  }
}

export class TransportCounts {

  readonly total: number;
  readonly planned: number;
  readonly inProcessing: number;
  readonly waitingForPull: number;
  readonly paused: number;
  readonly finished: number;
  readonly vehicles: number;

  constructor(counts?: any) {
    if (counts != null) {
      this.total = counts.total;
      this.planned = counts.planned;
      this.inProcessing = counts.inProcessing;
      this.waitingForPull = counts.waitingForPull;
      this.paused = counts.paused;
      this.finished = counts.finished;
      this.vehicles = counts.vehicles;
    }
  }

}
